<template>
  <div class="main">
    <div v-if="$cookies.get('auth_grade') > 80">
      <!-- <HR24 /> -->
      <oddJobHR24 />
    </div>
    <div class="jiazaishuju">
      <el-button
        v-if="['80', '60'].indexOf($cookies.get('auth_grade')) == -1"
        type="warning"
        size="mini"
        @click="
          is_view = true;
          is_views();
        "
      >
        详细数据
      </el-button>
    </div>
    <!-- <Company /> -->
    <div v-if="is_view">
      <div class="alldata">
        <div class="all_data">
          <div class="data">
            <h3>用户数据</h3>
            <div class="item_conent">
              <div
                class="item_data"
                v-for="(item, index) in data1"
                :key="index"
                @click="linkDate(item)"
              >
                <img src="/static/img/icon/data.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="data data1">
            <h3>
              今日数据

              <!-- <el-date-picker
                style="width: 130px; margin-left: 6px"
                v-model="copy_date"
                type="date"
                placeholder="请选择复制数据的日期"
                @change="copyText_date"
                :clearable="false"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <el-button
                type="primary"
                class="copybtn"
                ref="copybtn"
                style="margin-right: 6px"
                v-if="$cookies.get('auth_grade') > 80"
                size="mini"
                @click="copyText"
                :disabled="is_copyText"
                :data-clipboard-text="copy_value"
                >{{ !is_copyText ? "复制数据" : "加载中..." }}</el-button
              > -->
            </h3>
            <div class="item_conent">
              <div
                @click="linkDate_mon(item, '0')"
                v-for="(item, index) in data2"
                :key="index"
                class="item_data"
              >
                <img src="/static/img/icon/seed.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="data data3" v-if="$cookies.get('auth_grade') > 80">
            <h3>零工身份证认证</h3>
            <div class="item_conent">
              <div
                @click="data3Click(item, 'id_card')"
                v-for="(item, index) in odd_id_card_list"
                :key="index"
                class="item_data"
              >
                <img src="/static/img/icon/resume.png" alt />
                <div class="cursor">
                  <div>{{ item.city_name }}</div>
                  <div>{{ item.city_count }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="data data3" v-if="$cookies.get('auth_grade') > 80">
            <h3>零工健康证认证</h3>
            <div class="item_conent">
              <div
                @click="data3Click(item, 'health')"
                v-for="(item, index) in odd_health_list"
                :key="index"
                class="item_data"
              >
                <img src="/static/img/icon/resume.png" alt />
                <div class="cursor">
                  <div>{{ item.city_name }}</div>
                  <div>{{ item.city_count }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="data data3" v-if="$cookies.get('auth_grade') > 40">
            <h3>30日数据</h3>
            <div class="item_conent">
              <div
                @click="linkDate_mon(item, '1')"
                v-for="(item, index) in data_mon"
                :key="index"
                class="item_data"
              >
                <img src="/static/img/icon/yysj-jjfzgl02.png" alt />
                <div class="cursor">
                  <div>{{ item.title }}</div>
                  <div>{{ item.value }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
import Clipboard from "clipboard";
import HR24 from "@/components/daData/hr24";
import oddJobHR24 from "@/components/daData/oddjobHR24";
// import Company from '@/components/index/odd_company'

export default {
  components: { HR24, oddJobHR24 },
  data() {
    return {
      copy_date: new Date(),
      data1: [],
      data2: [],
      data_mon: [
        {
          title: "30日企业注册",
          value: 0,
          type: "odd_company_count",
          src: "odd_company",
        },
        {
          title: "30日需求发布",
          value: 0,
          type: "jd_cost_count",
          src: "jd_cost",
          is_is: true,
        },
        {
          title: "30日零工报名",
          value: 0,
          type: "apply_count",
          src: "odd_apply",
          is_is: true,
        },
        {
          title: "30日零工上工",
          value: 0,
          type: "odd_count",
          src: "",
          is_is: true,
        },
        {
          title: "30日零工身份证认证",
          value: 0,
          type: "id_auth_count",
          src: "id_card",
        },
        {
          title: "30日零工健康证认证",
          value: 0,
          type: "health_count",
          src: "health",
        },
      ],

      odd_id_card_list: [], // 身份证认证
      odd_health_list: [], // 健康证认证
      resumedata3: [],
      radarData: [],
      radar_data: [],

      all_place_data: [],
      seed_place_data: [],
      resume_count_city: [],
      radar_count: [],
      city_radar: 0,
      setting_resume_count: 0,
      big_resume_count: 0,
      small_resume_count: 0,
      agent_data: [
        {
          title: "客户总数",
          value: 0,
          type: "all_count",
          src: "all_company",
        },
        {
          title: "发布需求总数量",
          value: 0,
          type: "jd_cost_count",
          src: "jd_cost",
        },
        {
          title: "正常客户",
          value: 0,
          type: "not_expire_count",
          src: "not_expire",
        },
        {
          title: "关闭客户",
          value: 0,
          type: "expire_count",
          src: "expire",
        },
      ],
      agent_resume_data: [
        {
          //能点击详情时    加   is_is:true
          title: "城市总简历",
          value: 0,
          type: "all_resume_count",
          src: "all_company",
          is_is: true,
        },
        {
          title: "简历总数",
          value: 0,
          type: "all_agent_resume_count",
          src: "all_agent_resume",
        },
        {
          title: "城市线索总数",
          value: 0,
          type: "all_clue_count",
          src: "all_company",
          is_is: true,
        },
        {
          title: "线索总数",
          value: 0,
          type: "all_agent_clue_count",
          src: "all_agent_clue",
        },
      ],
      agent_login_data: [
        {
          title: "今日企业注册",
          value: 0,
          type: "odd_company_count",
          src: "odd_company",
        },
        {
          title: "今日需求发布",
          value: 0,
          type: "jd_cost_count",
          src: "jd_cost",
          is_is: true,
        },
        {
          title: "今日零工报名",
          value: 0,
          type: "apply_count",
          src: "odd_apply",
          is_is: true,
        },
        {
          title: "今日零工上工",
          value: 0,
          type: "odd_work",
          src: "",
          is_is: true,
        },
        {
          title: "今日零工身份证认证",
          value: 0,
          type: "id_auth_count",
          src: "id_card",
        },
        {
          title: "今日零工健康证认证",
          value: 0,
          type: "health_count",
          src: "health",
        },
      ],
      is_copyText: true,
      copy_value: "",
      is_view: false,
    };
  },

  created() {
    if (["80", "60"].indexOf(this.$cookies.get("auth_grade")) != -1) {
      this.agent_day_detail();
      this.is_view = true;
      this.is_views();
    }
  },

  methods: {
    agent_day_detail() {
      let obj = {
        username: this.$cookies.get("agent_username") || "",
        show_data: "experience_company",
        search_data: {},
        page: 0,
      };
      require("post", "/hr24_index_data/v1/agent_day_detail/", obj).then(
        (res) => {
          console.log("鑫泽", res.data);
          if (!res.code) {
            if (
              res.data.return_data.length > 0 &&
              Number(this.$cookies.get("experience_count") || 0) <
                res.data.experience_count
            ) {
              console.log("鑫泽");
              this.$confirm(`您有体验用户，是否查看`, "提示", {
                confirmButtonText: "前往查看",
                cancelButtonText: "我知道了",
                type: "warning",
              })
                .then(() => {
                  this.$cookies.set(
                    "experience_count",
                    res.data.experience_count
                  );
                  this.$router.push({
                    path: "company",
                    query: {
                      src: "experience_company",
                    },
                  });
                })
                .catch(() => {
                  this.$cookies.set(
                    "experience_count",
                    res.data.experience_count
                  );
                });
            }
          }
        }
      );
    },
    is_views() {
      this.init(); //初始化数据
      let data1_url = ""; //数值data1数据接口,页面右侧第一种
      let data2_url = ""; //数值data2数据接口,页面右侧第二种
      let obj = {};
      var date = new Date();
      let year = date.getFullYear(); //获取完整的年份(4位)
      let mouth = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
      let day = date.getDate(); //获取当前日(1-31)
      mouth = mouth >= 10 ? mouth : "0" + mouth;
      day = day >= 10 ? day : "0" + day;
      let datenew = year + "-" + mouth + "-" + day;
      if (
        this.$cookies.get("auth_grade") == 80 ||
        this.$cookies.get("auth_grade") == 60
      ) {
        data1_url = "/hrswork_index_data/v1/odd_company_data/";
        data2_url = "/hrswork_index_data/v1/odd_detail_data/";
        obj.username = this.$cookies.get("agent_username") || "";
      } else if (this.$cookies.get("auth_grade") == 90) {
        data1_url = "/hrswork_index_data/v1/odd_company_data/";
        data2_url = "/hrswork_index_data/v1/odd_detail_data/";
      } else {
        data1_url = "/hrswork_index_data/v1/odd_company_data/";
      }
      if (
        this.$cookies.get("auth_grade") == 80 ||
        this.$cookies.get("auth_grade") == 60
      ) {
        require("post", "/hrswork_index_data/v1/odd_detail_data/", obj).then(
          (res) => {
            if (!res.code) {
              this.agent_login_data.map((item, index) => {
                let prop = item.type;
                item.value = res.data[prop];
              });
            }
          }
        );
      }
      // if (this.$cookies.get('auth_grade') == 100) {
      //   require('post', '/hr24_index_data/v1/province_agent_day_statistics/', obj).then(
      //     (res) => {
      //       if (!res.code) {
      //         this.agent_login_data.map((item, index) => {
      //           let prop = item.type
      //           item.value = res.data[prop]
      //         })
      //       }
      //     }
      //   )
      // }

      require("post", data1_url, obj).then((res) => {
        if (!res.code) {
          this.data1.map((item, index) => {
            let prop = item.type;
            item.value = res.data[prop] || 0;
          });
          this.agent_data.map((item, index) => {
            let prop = item.type;
            item.value = res.data[prop];
          });
          this.all_place_data = res.data.all_place_data;

          this.seed_place_data = res.data.pay_place_data;
        }
      });

      require("post", data2_url, obj).then((res) => {
        if (!res.code) {
          if (
            this.$cookies.get("auth_grade") == 100 ||
            this.$cookies.get("auth_grade") == 90
          ) {
            this.cash_data = res.data.cash_data;
            this.data2.map((item, index) => {
              let prop = item.type;
              item.value = res.data[prop] || 0;
            });
          } else {
            this.agent_resume_data.map((item, index) => {
              let prop = item.type;
              item.value = res.data[prop] || 0;
            });
          }
        }
      });

      // require("post", "/hr24_index_data/v1/province_agent_resume_data/", obj).then(
      //   (res) => {
      //     if (!res.code) {
      //       this.resume_count_city = res.data.city_list;
      //       this.radar_count = res.data.radar_count;
      //       console.log(this.resume_count_city);
      //     }
      //   }
      // );
      require("post", "/hrswork_index_data/v1/Month_detail_data/", obj).then(
        (res) => {
          if (!res.code) {
            this.data_mon.map((item, index) => {
              let prop = item.type;
              item.value = res.data[prop];
              return item;
            });
          }
        }
      );

      if (this.$cookies.get("auth_grade") == 100) {
        // require("post", "/hr24_index_data/v1/month_all_count_elite/", obj).then(
        //   (res) => {
        //     console.log(res, "123");
        //     if (!res.code) {
        //       this.data_mon_eli[0].value = res.data.login_in_count;
        //     }
        //   }
        // );
        require("post", "/hrswork_index_data/v1/odd_auth_city/", obj).then(
          (res) => {
            if (!res.code) {
              this.odd_id_card_list = res.data.odd_id_card_list.slice(0, 8);
              this.odd_health_list = res.data.odd_health_list.slice(0, 8);
            }
          }
        );

        let obj_m = {
          show_data: "login_in",
        };

        //   this.copyText_date(datenew);
      }
      this.copyText_date(datenew);
    },
    copyText_date(e) {
      console.log("e", e);
      this.is_copyText = true;
      let obj = {
        date: e,
      };
      if (this.$cookies.get("auth_grade") == 100) {
        require("post", "/hrswork_index_data/v1/odd_detail_data/", obj).then(
          (res) => {
            if (!res.code) {
              let text = "";
              for (let key in res.data) {
                text += key + ":" + res.data[key] + ",";
              }
              console.log(text);
              this.copy_value = text;
              this.is_copyText = false;
            } else {
              this.$message.error("复制出错");
            }
          }
        );
      } else {
        require("post", "/hrswork_index_data/v1/odd_detail_data/", obj).then(
          (res) => {
            if (!res.code) {
              let text = "";
              for (let key in res.data) {
                text += key + ":" + res.data[key] + ",";
              }
              console.log(text);
              this.copy_value = text;
              this.is_copyText = false;
            } else {
              this.$message.error("复制出错");
            }
          }
        );
      }
    },
    copyText() {
      var _this = this;
      this.$nextTick(() => {
        console.log(this.copy_value, "cas");
        // console.log("aca", this.$refs.copybtn.$el.);
        var clipboard = new Clipboard(".copybtn");
        clipboard.on("success", (e) => {
          console.log("cjbsajbcas");
          this.$message.success("复制成功");
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          this.$message.error("不支持复制");
          // tips(this, '该浏览器不支持自动复制!', 'warning')
          // 释放内存
          clipboard.destroy();
        });
      });
    },
    init() {
      if (
        this.$cookies.get("auth_grade") == 80 ||
        this.$cookies.get("auth_grade") == 60
      ) {
        this.data1 = [
          {
            title: "客户总数",
            value: 0,
            type: "all_count",
            src: "all_company",
          },
          {
            title: "发布需求总数量",
            value: 0,
            type: "jd_cost_count",
            src: "jd_cost",
          },
          {
            title: "正常客户",
            value: 0,
            type: "not_expire_count",
            src: "not_expire",
          },
          {
            title: "关闭客户",
            value: 0,
            type: "expire_count",
            src: "expire",
          },
        ];
        this.data2 = [
          {
            title: "今日企业注册",
            value: 0,
            type: "odd_company_count",
            src: "odd_company",
          },
          {
            title: "今日需求发布",
            value: 0,
            type: "jd_cost_count",
            src: "jd_cost",
            is_is: true,
          },
          {
            title: "今日零工报名",
            value: 0,
            type: "apply_count",
            src: "odd_apply",
            is_is: true,
          },
          {
            title: "今日零工上工",
            value: 0,
            type: "odd_work",
            src: "",
            is_is: true,
          },
          {
            title: "今日零工身份证认证",
            value: 0,
            type: "id_auth_count",
            src: "id_card",
          },
          {
            title: "今日零工健康证认证",
            value: 0,
            type: "health_count",
            src: "health",
          },
        ];
      } else {
        this.data1 = [
          {
            title: "客户总数",
            value: 0,
            type: "all_count",
            src: "all_company",
          },
          {
            title: "发布需求总数量",
            value: 0,
            type: "jd_cost_count",
            src: "jd_cost",
          },
          {
            title: "正常客户",
            value: 0,
            type: "not_expire_count",
            src: "not_expire",
          },
          {
            title: "关闭客户",
            value: 0,
            type: "expire_count",
            src: "expire",
          },
        ];
        this.data2 = [
          {
            title: "今日企业注册",
            value: 0,
            type: "odd_company_count",
            src: "odd_company",
          },
          {
            title: "今日需求发布",
            value: 0,
            type: "jd_cost_count",
            src: "jd_cost",
            is_is: true,
          },
          {
            title: "今日零工报名",
            value: 0,
            type: "apply_count",
            src: "odd_apply",
            is_is: true,
          },
          {
            title: "今日零工上工",
            value: 0,
            type: "odd_work",
            src: "",
            is_is: true,
          },
          {
            title: "今日零工身份证认证",
            value: 0,
            type: "id_auth_count",
            src: "id_card",
          },
          {
            title: "今日零工健康证认证",
            value: 0,
            type: "health_count",
            src: "health",
          },
        ];
      }
    },
    showLine(myChart, mon_data, day, text) {
      myChart.setOption({
        title: {
          text: text,
          textStyle: {
            fontSize: 14,
            fontWeight: "normal",
          },
        },
        legend: {
          data: ["数量"],
        },
        xAxis: {
          data: day,
        },
        yAxis: {},
        label: {},
        tooltip: {},
        series: [{ name: "数量", type: "line", data: mon_data }],
      });
    },

    open_cash() {
      let s = "";
      for (let i in this.cash_data) {
        s += this.cash_data[i].company_name + " ";
        s += this.cash_data[i].compant_place_data + " ";
        s += this.cash_data[i].cash_gift_sum + " ";
        s += "/\r\n";
      }

      this.$alert(s),
        {
          confirmButtonText: "确定",
          callback: (action) => {},
        };
    },

    linkDate(e) {
      if (e.is_is) {
        // this.$message.warning("暂不开放");
        return false;
      }
      console.log(e);
      // 礼金记录打开小
      if (e.type == "cash_data") {
        this.open_cash();
        return;
      }
      // if (this.$cookies.get("auth_grade") != 90) {
      this.$router.push({ path: "/odd_company", query: { src: e.src } });
      // return false;
      // }
    },
    data3Click(e, val) {
      console.log(e, val);
      // if (e.title && this.$cookies.get("auth_grade") != 90) {
      this.$router.push({
        path: "/odd_city",
        query: { city_id: e.city_id, search: val },
      });
      // }
    },
    linkDate_mon(e, val) {
      console.log(e, val);
      // if (e.src) {
      this.$router.push({
        path: "/odd_data",
        query: { src: e.src, num: val },
      });
      // }
    },

    // 柱状图
    setOption(myChart, arr, arr1, text) {
      // console.log(myChart, arr, arr1, text);
      if (text == "用户地区分布") {
        var color = "rgba(159, 194, 248, 0.8)";
      }
      if (text == "充值用户地区分布") {
        var color = "rgba(51, 212, 144, 0.8)";
      }
      if (text == "简历地区分布") {
        var color = "rgba(73, 151, 255, 0.8)";
      }
      if (text == "简历线索地区分布") {
        var color = "rgba(239, 112, 46, 0.8)";
      }
      myChart.setOption({
        title: {
          text: text,
          textStyle: {
            fontSize: 14,
            fontWeight: "normal",
          },
        },
        tooltip: {},
        xAxis: {
          data: arr1,
        },
        yAxis: {},
        series: [
          {
            name: "人数",
            type: "bar",
            data: arr,
            color: color,
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.cursor {
  cursor: pointer;
}
.data3 {
  /* margin-top: 16px;
  height: 220px; */
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  justify-content: start;
  padding-top: 10px;
}

.main {
  margin-top: 46px;
  background: #ffff;
  border-radius: 4px;
  padding: 50px;
  min-height: 90vh;
}

/* .alldata {
  display: flex;
} */

.all_data > div {
  width: 49%;
}

.chart {
  width: 100%;
  display: flex;
  height: 230px;
  align-items: center;
  margin-bottom: 100px;
}

.all_data {
  width: 100%;
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
  z-index: 200;
}
.item_conent {
  width: calc(100% - 24px);
  padding: 12px;
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  justify-content: start;
  overflow: auto;
  background: #f7f7f7;
  border-radius: 12px;
}
.item_data {
  display: flex;
  position: relative;
  z-index: 200;
  height: 100px;
}

.data {
  width: 100%;
}
.data > h3 {
  width: 100%;
  padding: 0 0 12px 0;
  border-bottom: #bdbdbd solid 1px;
}

img {
  height: 30px;
  widows: 30px;
  margin-right: 10px;
  z-index: 200;
}

.data > .item_conent > div {
  margin-right: 30px;
  width: 20%;
}

.item_data div:first-child {
  color: #303030;
  font-size: 14px;
  margin-bottom: 20px;
}
.item_data div:last-child {
  color: #000;
  font-weight: bold;
  font-size: 20px;
}
.agent_data {
  position: relative;
  z-index: 10;
}
.kong {
  text-align: center;
}
.jiazaishuju {
  text-align: right;
}
.width_two {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/index/odd_job_index.vue